module.exports = __webpack_public_path__ + "static/media/css3.d73a1ede.png";